module.exports = __webpack_public_path__ + "media/images/icon_account_status_incomplete-f04921722f839a4b191b5b0afaa27d5c.svg";